var React = require('react');

function IconPinterestInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.8.188A5.61,5.61,0,0,0,3.748,11.02a18.277,18.277,0,0,1,.683-4.151,9.226,9.226,0,0,0-.036-1.75c0-.933.484-1.129.768-1.129.4,0,.96.154.96.8a.959.959,0,0,1-.607.941,6.892,6.892,0,0,0-.094.719A.924.924,0,0,0,6.448,7.559c1.386,0,1.6-1.925,1.6-2.455a2.2,2.2,0,0,0-2.2-2.216,2.527,2.527,0,0,0-2.6,2.519,4.353,4.353,0,0,0,.1.8c.419.068.376.642.2.8-.2.18-1.223.394-1.223-1.855A3.379,3.379,0,0,1,5.908,1.911a3.2,3.2,0,0,1,3.33,3.219A3.19,3.19,0,0,1,6.45,8.51,1.66,1.66,0,0,1,5.138,7.8a14.144,14.144,0,0,1-1.371,3.224A5.611,5.611,0,1,0,5.8.188Z","transform":"translate(-0.188 -0.188)"}));
}

IconPinterestInline.defaultProps = {"viewBox":"0 0 11.225 11.225","className":"svg-inline"};

module.exports = IconPinterestInline;

IconPinterestInline.default = IconPinterestInline;
